import { watch } from 'vue';
import { useMagicKeys } from '@vueuse/core';
import { useGlobalSearch } from '@/composables/useGlobalSearch';

export function useGlobalSearchShortcut() {
    const { open, openSearch, closeSearch } = useGlobalSearch();
    const { Meta_k, Ctrl_k } = useMagicKeys({
        passive: false,
        onEventFired(e) {
            if (e.key === 'k' && (e.metaKey || e.ctrlKey) && e.type === 'keydown') {
                e.preventDefault();
            }
        },
    });

    watch([Meta_k, Ctrl_k], ([meta, ctrl]) => {
        if (meta || ctrl) {
            open.value ? closeSearch() : openSearch();
        }
    });
}
